import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2rem;
  color: ${({ theme }) => theme.colors.danger};
  flex-wrap: wrap;
  gap: 2rem;

  & p {
    margin: 0;
  }
`
